

































import { Vue, Component, Ref, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import layoutStore from '@/modules/shared/layout.store'
import SearchResult from './SearchResult.vue'

@Component({
  components: { SearchResult }
})
export default class SearchDialog extends Vue {
  layoutModule = getModule(layoutStore, this.$store)

  query: string = ''
  isSearching: boolean = false

  @Ref('searchResult')
  readonly searchResult!: SearchResult

  @Watch('isVisible')
  onVisibleChanged(visible: boolean) {
    if (visible) {
      this.query = ''

      if (this.searchResult) {
        this.searchResult.reset()
      }
    }
  }

  get isVisible() {
    return this.layoutModule.isSearchDialogVisible
  }

  // this event is invoked by the v-dialog
  onDialogVisibilityChange(visible: boolean) {
    this.layoutModule.setSearchDialogVisible(visible)
  }
}
